/**
 * Pure helper for resolving the assistant's `app:*` link tokens to real in-app
 * routes. Kept free of React / Firebase imports so it's unit-testable in
 * isolation. Parsing the reply text into inline/block nodes lives in
 * assistantMarkdown.ts; the rendering lives in AssistantWidget.
 */

/** Resolve an `app:*` token from the KB to a real in-app route for this
 * caregiver, or null if it can't be built (e.g. no calendar yet). */
export function resolveAppLink(href: string, aid: string, cid: string | null): string | null {
  switch (href) {
    case 'app:calendar':
      return cid ? `/accounts/${aid}/calendars/${cid}/events` : null;
    case 'app:voice':
      return `/accounts/${aid}/voice`;
    case 'app:activity':
      return `/accounts/${aid}/activity`;
    case 'app:settings':
      return `/accounts/${aid}/settings`;
    case 'app:order':
      return `/accounts/${aid}/order`;
    default:
      return null;
  }
}
